let bundleSettings = document.querySelector("[data-bundle-settings]");
if (bundleSettings) {
  bundleSettings = JSON.parse(bundleSettings.textContent);
}
console.log("bundleSettings: ", bundleSettings);

const bundleCTA = document.querySelector("[data-bundle-cta]");
if (bundleCTA) {
  bundleCTA.addEventListener("click", async (event) => {
    event.preventDefault();

    bundleCTA.setAttribute("aria-busy", "true");
    bundleCTA.setAttribute("disabled", "disabled");

    const parentId = bundleSettings.productId;
    const bundleProductCount = bundleSettings.bundleProductIds.split(",").length;

    const items = bundleSettings.bundleProductIds.split(",").map((id) => {
      return {
        id,
        quantity: 1,
        properties: {
          _bundle_main_product: parentId,
          _bundle_discount: true,
          _bundle_dc_type: bundleSettings.dcType,
          _bundle_dc_price: bundleSettings.dcPrice,
          _bundle_dc_message: bundleSettings.dcMessage,
          _bundle_count: bundleProductCount,
        },
      };
    });

    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const sections = sectionsToBundle.join(",");
    const sectionsUrl = `${Shopify.routes.root}variants/${parentId}`;

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify({ items, sections, sectionsUrl }),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    bundleCTA.removeAttribute("aria-busy");
    bundleCTA.removeAttribute("disabled");

    const responseJson = await response.json();
    if (response.ok) {
      const cartContent = await (
        await fetch(`${Shopify.routes.root}cart.js`)
      ).json();
      cartContent["sections"] = responseJson["sections"];
      document.documentElement.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items")
              ? responseJson["items"]
              : [responseJson],
            cart: cartContent,
          },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent,
          },
        })
      );
    } else {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"],
          },
        })
      );
    }
  });
}
